import { CaretRightFilled } from '@ant-design/icons';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { PreCaptureInformationDialog } from './PreCaptureInformationDialog';
import { listSandboxKeys } from '../../services/account/api';
import { useAuth } from '../../contexts/auth';
import { getSettingsByKey } from '../../services/settings/api';

export function StartCapture() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [primaryColor, setPrimaryColor] = useState('#00ABAB');
  const { currentWorkspace } = useAuth();

  const handleOpen = async () => {
    setLoading(true);
    try {
      const sandboxRes = await listSandboxKeys(currentWorkspace);
      const settingsRes = await getSettingsByKey(sandboxRes.capture_key);
      setPrimaryColor(settingsRes.data.message.primary_color || '#00ABAB');
    } catch (e) {
      setPrimaryColor('#00ABAB');
    } finally {
      setLoading(false);
      setOpen(true);
    }
  };

  return (
    <div>
      <Button
        className="rounded-full bg-primary px-6 text-white shadow-none items-center text-center"
        icon={<CaretRightFilled />}
        onClick={handleOpen}
        type="primary"
        loading={loading}
      >
        <FormattedMessage id="topbar.tryCapture" />
      </Button>
      <PreCaptureInformationDialog
        open={open}
        onCancel={() => setOpen(false)}
        primaryColor={primaryColor}
      />
    </div>
  );
}
